type ProspectStageIconProps = {
  readonly stepWidth: number;
  readonly stepSpacing: number;
};

export enum ProspectStage {
  Lead = 'Lead',
  Discovery = 'Discovery',
  Proposal = 'Proposal',
  Commitment = 'Commitment',
  Onboarding = 'Onboarding',
  Won = 'Won',
  OnHold = 'On hold',
  Lost = 'Lost',
}
export const stageList = ['Lead', 'Discovery', 'Proposal', 'Commitment', 'Onboarding', 'Won', 'On Hold', 'Lost'];

function ProspectStageIconInternal({
  barColors,
  stepWidth,
  stepSpacing,
}: { readonly barColors: string[] } & ProspectStageIconProps) {
  const numSteps = barColors.length;
  const totalWidth = Math.max(stepWidth * numSteps + stepSpacing * (numSteps - 1), 0);
  const stepBarWidth = Math.max(stepWidth, 0);
  return (
    <svg
      width={`${totalWidth}`}
      height="4"
      viewBox={`0 0 ${totalWidth} 4`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_558_34461)">
        {barColors.map((barColor: string, index: number) => (
          <rect
            width={`${stepBarWidth}`}
            x={`${stepWidth * index + stepSpacing * index}`}
            height="4"
            fill={barColor}
            // eslint-disable-next-line react/no-array-index-key -- This array is fixed, so index is fine here
            key={index}
          />
        ))}
      </g>
      <defs>
        <clipPath id="clip0_558_34461">
          {}
          <rect width={`${totalWidth}`} height="4" rx="2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function LostOrOnHoldIcon(props: ProspectStageIconProps) {
  const barColors = ['#E8EAED', '#E8EAED', '#E8EAED', '#E8EAED', '#E8EAED', '#E8EAED'];
  return <ProspectStageIconInternal barColors={barColors} {...props} />;
}

function LeadIcon(props: ProspectStageIconProps) {
  const barColors = ['#14B8A6', '#E8EAED', '#E8EAED', '#E8EAED', '#E8EAED', '#E8EAED'];
  return <ProspectStageIconInternal barColors={barColors} {...props} />;
}

function DiscoveryIcon(props: ProspectStageIconProps) {
  const barColors = ['#14B8A6', '#14B8A6', '#E8EAED', '#E8EAED', '#E8EAED', '#E8EAED'];
  return <ProspectStageIconInternal barColors={barColors} {...props} />;
}

function ProposalIcon(props: ProspectStageIconProps) {
  const barColors = ['#14B8A6', '#14B8A6', '#14B8A6', '#E8EAED', '#E8EAED', '#E8EAED'];
  return <ProspectStageIconInternal barColors={barColors} {...props} />;
}

function CommitmentIcon(props: ProspectStageIconProps) {
  const barColors = ['#14B8A6', '#14B8A6', '#14B8A6', '#14B8A6', '#E8EAED', '#E8EAED'];
  return <ProspectStageIconInternal barColors={barColors} {...props} />;
}

function OnboardingIcon(props: ProspectStageIconProps) {
  const barColors = ['#14B8A6', '#14B8A6', '#14B8A6', '#14B8A6', '#14B8A6', '#E8EAED'];
  return <ProspectStageIconInternal barColors={barColors} {...props} />;
}

function WonIcon(props: ProspectStageIconProps) {
  const barColors = ['#14B8A6', '#14B8A6', '#14B8A6', '#14B8A6', '#14B8A6', '#14B8A6'];
  return <ProspectStageIconInternal barColors={barColors} {...props} />;
}

export enum StageIconSize {
  Small = 'SMALL',
  Large = 'LARGE',
}

const STEP_WIDTH_FOR_SIZE = {
  [StageIconSize.Small]: 14.8333,
  [StageIconSize.Large]: 42.17,
};

const STEP_SPACING_FOR_SIZE = {
  [StageIconSize.Small]: 1,
  [StageIconSize.Large]: 3,
};

export function StageIcon({
  stageName,
  size = StageIconSize.Small,
}: {
  readonly stageName: string;
  readonly size?: StageIconSize;
}) {
  const prospectStageIconProps = {
    stepWidth: STEP_WIDTH_FOR_SIZE[size],
    stepSpacing: STEP_SPACING_FOR_SIZE[size],
  };
  switch (stageName) {
    case 'Lead':
      return <LeadIcon {...prospectStageIconProps} />;
    case 'Discovery':
      return <DiscoveryIcon {...prospectStageIconProps} />;
    case 'Proposal':
      return <ProposalIcon {...prospectStageIconProps} />;
    case 'Commitment':
      return <CommitmentIcon {...prospectStageIconProps} />;
    case 'Onboarding':
      return <OnboardingIcon {...prospectStageIconProps} />;
    case 'Won':
      return <WonIcon {...prospectStageIconProps} />;
    default:
      return <LostOrOnHoldIcon {...prospectStageIconProps} />;
  }
}
